import { __ } from '@wordpress/i18n';
import { IoPeopleSharp,IoSparklesSharp,IoNewspaperSharp } from "react-icons/io5";

import {
   NeedHelpIcon,
   DocumentationIcon,
   StarSolidIcon
} from './blockIcons';

function Sidebar() {
    return (
        <div className="th-sidebar">
        <div className="sidebar-section">
            <div className="section">
                <div className="section-heading">
                <StarSolidIcon />
                <h3>{__('Love Vayu Blocks?', 'vayu-blocks')}</h3>
                </div>
                <p>{__('Show some love for Vayu Blocks by rating us and helping us grow more and do improvements.', 'vayu-blocks')}</p>
                <a href="https://wordpress.org/support/plugin/vayu-blocks/reviews/#new-post" target="_blank" className="sidebar-link">
                <StarSolidIcon />{__('Submit review', 'vayu-blocks')} 
                </a>
            </div>
        <hr />
        <div className="section">
            <div className="section-heading">

            <DocumentationIcon />
            <h3>{__('Documentation', 'vayu-blocks')} </h3>
            </div>

            <p>{__('Go through the easy documentation to get familiar with Vayu Blocks and its Features.', 'vayu-blocks')}</p>
            <a href="https://themehunk.com/docs/vayu-blocks/" target="_blank" className="sidebar-link">
            {__('View Documentation', 'vayu-blocks')} 
            </a>
        </div>
        <hr />
            <div className="section">
                <div className="section-heading">
                <NeedHelpIcon />
                <h3>{__('Need Help?', 'vayu-blocks')}</h3>
                </div>
                <p>{__('Have a question, we are happy to help! Get in touch with our support team.', 'vayu-blocks')}</p>
                <a href="https://themehunk.com/contact-us/" target="_blank" className="sidebar-link">
                {__('Submit a Ticket', 'vayu-blocks')} 
                </a>
            </div>
        </div>
        </div>
    );
}

export default Sidebar;
